  <div class="mydocma-dialog-container">

    <div class="mydocma-dialog-header" *ngIf="!(appContainerService.mobileView$ | async); else mobileHeader">
      <div class="mydomca-dialog-header-title">
        {{title$ | async}}
      </div>
      <div>
        <button mat-icon-button type= "button" (click)="onCancel()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="mydocma-dialog-body">
      <mydocma-loader [size]="'small'" class="mydocma-mm-loader" *ngIf="(loading$ | async) || (saving$ | async)"></mydocma-loader>
      <div class="le-dialog-content">
        <mat-tab-group #tabGroupLayout class="mydocma-tab-group" class="le-tab-group" [class.le-tab-group-mobile]="appContainerService.mobileView$ | async" [selectedIndex]="(dialogData.isNew ? 0 : 1)" (selectedTabChange)="onSelectTab($event)">
          <mat-tab>
            <ng-template mat-tab-label>
              <mydocma-custom-mat-icon [iconName]="'sort'"></mydocma-custom-mat-icon>
              {{'MM.layout.PageDetails' | translate}}
            </ng-template>
            <ng-container>
              <mydocma-mm-layout-edit-details #editDetails></mydocma-mm-layout-edit-details>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mydocma-custom-mat-icon
                fontSet="material-icons-outlined"
                [iconName]="'view_column'"></mydocma-custom-mat-icon>
              {{'MM.layout.PageFields' | translate}}
            </ng-template>
            <ng-container>
              <mydocma-mm-layout-edit-fields #editFields></mydocma-mm-layout-edit-fields>
            </ng-container>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mydocma-custom-mat-icon fontSet="material-icons-outlined" [iconName]="'filter_alt'"></mydocma-custom-mat-icon>
              {{'MM.layout.PageFilters' | translate}}
              <sup *ngIf="filterTabRequired" style="margin-bottom: 10px;">*</sup>
            </ng-template>
            <ng-container>
              <mydocma-mm-layout-edit-filters #editFilters></mydocma-mm-layout-edit-filters>
            </ng-container>
          </mat-tab>
       </mat-tab-group>
      </div>
    </div>

    <div class="mydocma-dialog-footer" *ngIf="!(appContainerService.mobileView$ | async)">
      <div style="margin-right: 10px">
        <button mat-stroked-button class="mydocma-btn"
                (click)="onCancel()">
          {{'MM.general.button.cancel' | translate}}
        </button>
      </div>
      <div>
        <button mat-stroked-button class="mydocma-btn-primary"
                (click)="onSaveChanges()"
                [disabled]="!(hasChanges$ | async) || !(canSave$ | async) || (saving$ | async)"
                matTooltip="{{cantSaveTooltip$ | async}}">
          {{'MM.general.button.save' | translate}}
        </button>
      </div>
    </div>

    <ng-template #mobileHeader>
      <div *ngIf="(appContainerService.mobileView$ | async)" class="mydocma-dialog-header">

        <div class="mm-pane-header mydocma-detail-header" fxFlex="row" fxFlexAlign="center space-between" style="flex: 1 1 100%">
          <div class="mm-pane-header-title"
               style="display: block">
            <div class="mm-pane-header-text">{{title$ | async}}</div>
          </div>
          <button
            style="display: block"
            mat-icon-button type="button" (click)="onCancel()">
            <mat-icon>close</mat-icon>
          </button>
        </div>

      </div>
    </ng-template>

    <div class="mobile-pane-footer" *ngIf="(appContainerService.mobileView$ | async)">
      <div style="margin-right: 10px">
        <button mat-stroked-button (click)="onCancel()" class="mydocma-btn">
          {{'MM.general.button.cancel' | translate}}
        </button>
      </div>
      <div style="margin-right: 10px">
        <button mat-stroked-button type="button" class="mydocma-btn-primary" [disabled]="!(hasChanges$ | async) || !(canSave$ | async) || (saving$ | async)" (click)="onSaveChanges()">
          {{'MM.general.button.save' | translate }}
        </button>
      </div>
    </div>
  </div>
